"use strict";

import Common from "./../core/Common";
import isMobile from "ismobilejs";

/**
 * Generic Preloader for prototyping
 * @class
 */
export default class GenericPreloaderScene extends P3.Scene {
    constructor() {
        super();

        this.loaded = 0;
        this._bar = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._barWidth = 375;
        this._text = createText("loading", {fill: 0x000000});

    }

    init() {
        super.init();

        this._bar.position.set(Common.STAGE_WIDTH * 0.5 - this._barWidth * 0.5, P3.View.height * 0.5);
        this._bar.width = 0;
        this._bar.height = 25;
        this._bar.anchor = new PIXI.Point(0, 0.5);
        this._bar.tint = 0x000000;

        this._text.anchor.set(0.5);
        this._text.x = Common.STAGE_WIDTH * 0.5;
        this._text.y = Common.STAGE_HEIGHT * 0.5 - 75;

        this.addChild(this._bar, this._text);
    }

    destroy() {
        super.destroy({children: true});
    }

    appear() {
        super.appear();
    }

    resize() {
        this.x = (P3.View.width - Common.STAGE_WIDTH) * 0.5;
    }

    update() {
        const loaded = Math.min(1, this.loaded);
        this._bar.width = loaded * this._barWidth;
    }

    onLoadComplete() {
        let overlay = P3.utils.sprite(PIXI.Texture.WHITE, this, new PIXI.Point(0.5, 0));
        overlay.width = Common.STAGE_WIDTH;
        overlay.height = Common.STAGE_HEIGHT;
        overlay.x = Common.STAGE_WIDTH * 0.5;
        overlay.alpha = 0;
        TweenMax.to(overlay, 0.5, {alpha: 1, ease: Power0.easeNone, onComplete: ()=> this.end()});
    }

    end() {
        this.signals.next.dispatch(this);
    }
}
